class Animation {
  // TODO: CURVES IS A PLAIN OBJECT. THIS IS OKAY. IT WILL BE REPLACED WITH
  // FUNCTIONS FOR DEFINING THE CURVE AND WHEN TO RENDER.
  constructor({ element, property, styleFn, curves } = {}) {
    this.element = element;
    this.property = property;
    this.styleFn = styleFn;
    this.curves = curves;
  }

  // THINK I MIGHT BE GOING ABOUT THIS WRONG. WORRY LESS ABOUT SPECIFIC
  // STYLES. MORE ABOUT WHAT THE ANIMATION DOES. MOVE. SCALE. FADE. BG COLOR. ETC.

  // TODO: CHANGE THIS SO IT CHECKS TO SEE IF A RANDER SHOULD HAPPEN.
  render() {
    const animationValues = {};

    for (const [curveName, curve] of Object.entries(this.curves)) {
      let animationValue = curve.startValue;

      if (window.scrollY >= curve.startY) {
        if (window.scrollY <= curve.endY) {
          animationValue = curve.coefficients.reduce((v, c, i) => (v + c * window.scrollY ** (i + 1)), 0) + curve.intercept;
        } else {
          animationValue = curve.endValue;
        }
      }

      animationValues[curveName] = animationValue;
    }

    this.element.style[this.property] = this.styleFn(animationValues);
  }
}

export default Animation;
